// extracted by mini-css-extract-plugin
export default {"paneContentModal":"PageTemplate-module__paneContentModal___169vr"};